module.exports = __webpack_public_path__ + "img/the-graph.315ba911.svg";